module.exports = __webpack_public_path__ + "img/task-follow.8392b0ba.png";